import React from "react";
import "../App.css";

function Header() {
  return (
    <header className="header">
      <h1 className="header-title">RiderSync</h1>
      <h1 className="faq">FAQ</h1>
    </header>
  );
}

export default Header;
